/**
 * Action creators for Landing gear
 *
 * @author Alexander Nagelberg
 */
import { genericFetchingActionCreator } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'

/**
 * Action creator to complete registration. Calls server without args.
 * On success, it dispatches user. On error, dispatches error object.
 */
export const completeRegistration = () => async dispatch => {
  dispatch(genericFetchingActionCreator('CURRENT_USER', 'fetching'))
  try {
    const response = await fetch('/lgyhub/api/users/register', {
      method: 'GET',
      credentials: 'include'
    })
    const responseJson = await catchCommonErrors(dispatch, response, 'registering user')
    
    if (responseJson.status >= 400) {
      dispatch(genericFetchingActionCreator('CURRENT_USER', 'error', responseJson))
      throw new Error(responseJson.errors[0].message)
    } else {
      dispatch(genericFetchingActionCreator('CURRENT_USER', 'fetched', responseJson))
    }
  } catch (error) {
    console.error('Failed to complete user registration: ', error)
  }
}